import React from "react";

function BurgerMenu({ menuOpen, setMenuOpen }) {
  // Only show on mobile, CSS will hide on desktop
  return (
    <div
      className={`burger ${menuOpen ? "open" : ""}`}
      onClick={() => setMenuOpen((open) => !open)}
    >
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
    </div>
  );
}

export default BurgerMenu;
